import { loadGlossaire } from '@data/content-loaders';
import type { GlossaireEntry } from '@data/schemas/glossaire';
import { normalize } from '@features/search';
import { html } from 'lit';

export async function renderGlossairePage(): Promise<unknown> {
  const g = await loadGlossaire();

  const matches = (e: GlossaireEntry, q: string): boolean =>
    normalize(`${e.terme} ${e.abreviations.join(' ')} ${e.definition}`).includes(q);

  const render = (e: GlossaireEntry) => html`
    <div class="list-card">
      <span class="list-card-badge">${e.abreviations.length > 0 ? e.abreviations.join(', ') : e.categorie}</span>
      <span class="list-card-title">${e.terme}</span>
      <span class="list-card-sub">${e.definition}</span>
    </div>
  `;

  return html`
    <div class="list-page">
      <header class="list-page-header">
        <h1 class="list-page-title" data-morph data-morph-duration="1500">Glossaire</h1>
        <p class="list-page-subtitle">${g.termes.length} termes : abreviations mecaniques, formules, concepts JdR.</p>
      </header>
      <cof2-search-grid
        .items=${g.termes}
        .predicate=${matches}
        .renderItem=${render}
        placeholder="Rechercher un terme..."
      ></cof2-search-grid>
    </div>
  `;
}
